import { render } from "./GoldcastText.vue?vue&type=template&id=29c8aac2"
import script from "./GoldcastText.vue?vue&type=script&lang=js"
export * from "./GoldcastText.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./GoldcastText.vue?vue&type=style&index=0&id=29c8aac2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__